/** @format */

import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ProductSocialContentState } from '../../model';

/**
 * @description
 * Returns either the number of total results, the individual social content items (with products and media), or just the media / images for the social items
 */

export const selectProductSocialContentState =
	createFeatureSelector<ProductSocialContentState>('productSocialContent');

export const selectProductSocialContentNumberResults = createSelector(
	selectProductSocialContentState,
	(state) => state.resultsCount
);

export const selectProductSocialContentItems = createSelector(
	selectProductSocialContentState,
	(state) => state.items
);

export const selectProductSocialContentImages = createSelector(
	selectProductSocialContentState,
	(state) => state.items.map((item) => item.media)
);

export const selectProductSocialContentModal = createSelector(
	selectProductSocialContentState,
	(state) => state.socialModal
);
